import LlamadaService from './llamada_service.js';
import ConfigService from './config_service.js';
import LoginService from './login_service.js';

const llamada = new LlamadaService();
const configService = new ConfigService();
const config = configService.getConfig();
const loginService = new LoginService();
export default class DatosParametricosService {
	getEspecialidades(data) {		
		data.tipoDatoParametrico="especialidades";
		return this.getDatosParametricos(data);
	}

	getSubEspecialidades(data) {		
		data.tipoDatoParametrico="subespecialidades";
		return this.getDatosParametricos(data);
	}

	getDiagnosticos(data) {
		data.tipoDatoParametrico="diagnosticos";
		return this.getDatosParametricos(data);
	}

	getTipoInternacion(data) {
		data.tipoDatoParametrico="tipo_internacion";
		return this.getDatosParametricos(data);
	}

	getAntecedentes(data) {
		data.tipoDatoParametrico="antecedentes";
		return this.getDatosParametricos(data);
	}

	getVias(data) {
		data.tipoDatoParametrico="vias";
		return this.getDatosParametricos(data);
	}

	getTipoComplicaciones(data) {
		data.tipoDatoParametrico="complicaciones";
		return this.getDatosParametricos(data);
	}

	getCondicionesAlta(data) {
		data.tipoDatoParametrico="condicion_alta";
		return this.getDatosParametricos(data);
	}

	getComplicacionesIop(data) {
		data.tipoDatoParametrico="complicaciones_intraoperatorio";
		return this.getDatosParametricos(data);
	}

	getComplicacionesPop(data) {
		data.tipoDatoParametrico="complicaciones_postoperatorio";
		return this.getDatosParametricos(data);
	}

	getDatosParametricos(data) {
		data.action = 'get';
		const token = loginService.getToken();
		return llamada.sendPost(config.baseUrl + 'DatoParametricoWebService.php?token='+token, data);
	}
}

